<template>
    <!-- ======= 1.02 Home Area ====== -->
    <div class="homeArea">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="homeSlider1 owl-carousel">
                        <div class="SingleHomeSlider1">
                            <div class="row">
                                <div class="col-md-6 col-lg-7">
                                    <div class="homeImgTable">
                                        <div class="homeImg">
                                            <img src="../../assets/images/illustration-home-goal.png" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-5">
                                    <div class="homeContent">
                                        <span class="topTxt">Simples &nbsp; - &nbsp; Cómodo &nbsp; - &nbsp; Seguro</span>
                                        <span class="h2 homeTitle">Gestão centralizada de pagamentos</span>
                                        <p>O <span class="qp">Quick-e-Pay</span> é um serviço de pagamentos que explora
                                            carteiras móveis como
                                            a forma principal de pagamentos online.</p>
                                        <div class="homeBtn">
                                            <a :href="settings.app_url + '/register'" class="btnOne Btn"><i class="icofont icofont-rocket-alt-2"></i>Regista-te
                                                já</a>
                                            <a href="#" class="btnTwo Btn">Como funciona?</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SingleHomeSlider1">
                            <div class="row">
                                <div class="col-md-6 col-lg-5">
                                    <div class="homeContent">
                                        <span class="topTxt">Registar &nbsp; - &nbsp; Associar &nbsp; - &nbsp; Operar</span>
                                        <span class="h2 homeTitle">Faça uso da sua conta comerciante de forma eficaz.</span>
                                        <p>Sem nenhuma burocracia, crie sua conta comerciante, associa a sua conta movel
                                            comerciante e
                                            já esta! Comece a integrar o <span class="qp">Quick-e-Pay</span> ao seu
                                            serviço.</p>
                                        <div class="homeBtn">
                                            <a :href="settings.app_url + '/register'" class="btnOne Btn"><i class="icofont icofont-rocket-alt-2"></i>Comece
                                                agora</a>
                                            <a href="#" class="btnTwo Btn">Saiba como</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-7">
                                    <div class="homeImgTable">
                                        <div class="homeImg">
                                            <img src="../../assets/images/Artboard+1+copy.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SingleHomeSlider1">
                            <div class="row">
                                <div class="col-md-6 col-lg-5">
                                    <div class="homeContent">
                                        <span class="topTxt">Entrar &nbsp; - &nbsp; Comprar &nbsp; - &nbsp; Pagar</span>
                                        <span class="h2 homeTitle">Receba pagamentos de forma instantânea.</span>
                                        <p>Esqueça os processos complicados para integrar formas de receber os seus
                                            pagamentos.</p>
                                        <p>Integre os <span class="qp">Quick-e-Pay </span> ao seu negócio sem nenhum
                                            custo de implemantação ou manutenção.
                                        </p>
                                        <div class="homeBtn">
                                            <a :href="settings.app_url + '/register'" class="btnOne Btn"><i class="icofont icofont-rocket-alt-2"></i>Comece
                                                agora</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-7">
                                    <div class="homeImgTable">
                                        <div class="homeImg">
                                            <img src="../../assets/images/new_logos/instant-response.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ======= /1.02 Home Area ====== -->
</template>

<script>
  import {activate} from '../../assets/js/carossel'
  import Settings from '@/database/settings.json'

  export default {
    name: 'site-top-slider',
    data() {
      return {
        settings: Settings
      }
    },
    mounted() {
      activate()
    }
  }
</script>

<style scoped>
    .homeArea {
        background-color: #f0f5fa;
    }

    .qp {
        color: #288feb;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/site/SiteTopSlider.vue